/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card image instance
 *
 * @module enervee_utils.product_card
 */

function productCardCertBadgesDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '=',
            numBadges: '=?',
        },
        controller: productCardCertBadgesController,
        template: require('./certBadgesView.html')
    };
}

productCardCertBadgesController.$inject = ['$scope', 'UtilitySelectorCookieService'];
function productCardCertBadgesController ($scope, UtilitySelectorCookieService) {
    $scope.numBadges = angular.isDefined($scope.numBadges) ? $scope.numBadges : 1;

    var certs = [];
    $scope.product.certifications = [];
    if ($scope.product.hasOwnProperty('certifications_json')) {
        certs = $scope.product.certifications_json;
    }
    var utilityId = UtilitySelectorCookieService.getUtilityId();
    if (certs.hasOwnProperty(utilityId)) {
        $scope.product.certifications = certs[utilityId];
    }
    if (certs.hasOwnProperty('all')) {
        $scope.product.certifications = $scope.product.certifications.concat(certs.all);
    }

    $scope.product.certificationBadges = $scope.product.certifications.filter(function (cert) {
        return cert.is_badge;
    });

    $scope.certBadges = $scope.product.certificationBadges.slice(0, $scope.numBadges);
}

module.exports = productCardCertBadgesDirective;
